/**
 * This is primarily based on the model in Django.
 */
export class UserModel {
    public address1?: string;
    public address2?: string;
    public amount_spent = 0;
    public can_invoice = false;
    public city?: string;
    public company?: string;
    public country?: string; // 2 letter iso country code
    public created_at?: string; // ISO8601 String ex) "2015-08-13T18:36:15.557000Z"
    public download_w9 = false;
    public email?: string;
    public first_name?: string;
    public foundry: unknown[] = [];
    public hijacked = false;
    public id?: number;
    public is_active = false;
    public is_staff = false;
    public is_superuser = false;
    public is_verified = true;
    public last_name?: string;
    public phone?: string;
    public state?: string; // 2 letter US State
    public tax_exempt = false;
    public twitter?: string;
    public username?: string;
    public updated_at?: string;
    public vat?: boolean;
    public website?: string;
    public zipcode?: string;
}
